var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-view",on:{"click":_vm.bigImg}},[_c('div',{staticClass:"img-layer"},[_c('div',{staticStyle:{"width":"100%","height":"100%","display":"flex","justify-content":"center"}},[_c('div',{staticClass:"img"},[_c('img',{staticStyle:{"background":"#fff"},attrs:{"src":_vm.imgSrc}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.2@vue-loader/lib/template-compiler?{"id":"data-v-0c216c14","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/largephoto.vue
// module id = null
// module chunks = 